module.exports = __webpack_public_path__ + "img/shareArrow.df76e3b1.png";